import { FC, ReactNode, useCallback } from 'react'
import { ConfirmModalLayout } from 'components/features/pfm/ConfirmModalLayout/ConfirmModalLayout'

export type ConfirmModalProps = {
  children?: ReactNode
  onCancel: () => void
  primaryButton?: ReactNode
  secondaryButton?: ReactNode
}

export const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { children, onCancel, primaryButton, secondaryButton } = props

  const handleCancel = useCallback(() => {
    onCancel && onCancel()
  }, [onCancel])

  return (
    <ConfirmModalLayout
      onCancel={ handleCancel }
      buttons={ [primaryButton, secondaryButton] }
    >
      { children }
    </ConfirmModalLayout>
  )
}

export default ConfirmModal
